(function () {
  'use strict';

  const root = document.querySelector('[data-bogo-page]');
  if (!root) return;

  const greenId = parseInt(root.dataset.greenVariantId, 10);
  const pinkId = parseInt(root.dataset.pinkVariantId, 10);
  const atcBtn = root.querySelector('[data-bogo-atc]');
  function selectedCombo() {
    const input = root.querySelector('[data-bogo-combo]:checked');
    return input ? input.value : 'green-green';
  }

  function itemsForCombo(combo) {
    if (!greenId || !pinkId) return [];
    if (combo === 'pink-pink') return [{ id: pinkId, quantity: 2 }];
    if (combo === 'mixed') return [{ id: greenId, quantity: 1 }, { id: pinkId, quantity: 1 }];
    return [{ id: greenId, quantity: 2 }];
  }

  function updateComboCards() {
    root.querySelectorAll('[data-bogo-combo-card]').forEach((card) => {
      const input = card.querySelector('[data-bogo-combo]');
      card.classList.toggle('is-selected', input && input.checked);
    });
    updateGalleryForCombo();
  }

  function updateGalleryForCombo() {
    const combo = selectedCombo();
    const gallery = root.querySelector('[data-pdp-gallery]');
    let image = root.dataset.greenImage || '';
    let mediaId = root.dataset.greenMediaId || '';
    if (combo === 'pink-pink') {
      image = root.dataset.pinkImage || image;
      mediaId = root.dataset.pinkMediaId || mediaId;
    }
    if (!image) return;
    document.dispatchEvent(
      new CustomEvent('gwong:gallery:set-hero', {
        detail: { image, media_id: mediaId, gallery },
      })
    );
  }

  root.querySelectorAll('[data-bogo-combo]').forEach((input) => {
    input.addEventListener('change', updateComboCards);
  });

  if (atcBtn) {
    atcBtn.addEventListener('click', async () => {
      if (!window.Gwong?.cart) return;
      const items = itemsForCombo(selectedCombo());
      if (!items.length) return;

      atcBtn.disabled = true;
      const label = atcBtn.textContent;
      atcBtn.textContent = atcBtn.dataset.loadingLabel || 'Adding…';

      try {
        await window.Gwong.cart.add(items);
        const cart = await window.Gwong.cart.fetch();
        window.Gwong.cart.render(cart);
        if (window.gwongConfig?.bundleDiscountAutomatic === false) {
          const drawer = document.querySelector('[data-cart-drawer]');
          if (drawer) drawer.dataset.bundleApplied = 'true';
        }
        window.Gwong.cart.open();
      } catch (e) {
        alert('Could not add bundle. Please try again.');
      } finally {
        atcBtn.disabled = false;
        atcBtn.textContent = label;
      }
    });
  }

  updateComboCards();

  const stickyBtn = document.querySelector('[data-sticky-atc-btn]');
  if (stickyBtn && atcBtn) {
    stickyBtn.addEventListener('click', () => {
      if (!atcBtn.disabled) atcBtn.click();
    });
  }
})();
